import axios from 'axios';

export const kitchenService = {
  async fire(orderId, round = null, itemIds = null) {
    const ids = itemIds === null ? null : [...new Set(itemIds.map(Number))].sort((a,b)=>a-b);
    if (ids && !ids.length) throw new Error('Select at least one item.');
    const key = `kitchen-fire:${orderId}:${round || "all"}:${ids ? ids.join(',') : 'all'}`;
    const commandId = sessionStorage.getItem(key) || crypto.randomUUID();
    sessionStorage.setItem(key, commandId);
    try {
      const response = await axios.post(`/kitchen/orders/${orderId}/commands`, { command_id: commandId, action: 'fire', ...(round ? {round} : {}), ...(ids ? {item_ids:ids} : {}) });
      sessionStorage.removeItem(key);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status < 500) sessionStorage.removeItem(key);
      throw error;
    }
  },
  async serve(orderId, itemIds) {
    const ids=[...new Set(itemIds)].sort((a,b)=>a-b);
    const key=`kitchen-serve:${orderId}:${ids.join(',')}`;
    const commandId=sessionStorage.getItem(key) || crypto.randomUUID();
    sessionStorage.setItem(key,commandId);
    try {
      const {data}=await axios.post(`/kitchen/orders/${orderId}/served`,{command_id:commandId,item_ids:ids});
      sessionStorage.removeItem(key);
      return data;
    } catch(error) {
      if(error.response && error.response.status<500)sessionStorage.removeItem(key);
      throw error;
    }
  },
  async addRound(orderId) { return (await axios.post(`/kitchen/orders/${orderId}/rounds`, {})).data; },
  async moveToRound(orderId, itemId, round) { return (await axios.post(`/kitchen/orders/${orderId}/items/${itemId}/round`, {round})).data; },
  async state(orderId) {
    return (await axios.get(`/kitchen/orders/${orderId}`)).data;
  }
};
